import React, { useContext } from 'react'
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Button, Container, Paper, TextField, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { PostChangeHeldTimes } from '../DataFetch/ManagementAPI';
import { useErrorDialog } from '../Component/useErrorDialog';
import { useSuccessDialog } from '../Component/useSuccessDialog';
import { useConfirmDialog } from '../Component/useConfirmDialog';
import { SessionContext } from '../ManagementRoot';
import { useHeldTimes } from '../DataFetch/useHeldTimes';

/**
 * 入力フォームの型
 */
interface FormInputType {
    heldTimesJP: string,
    heldTimesEN: string,
}

/**
 * 開催回変更画面
 */
export function ChangeHeldTimes() {

    const {heldTimes, isLoading, mutate} = useHeldTimes();

    const {waitConfirm, ConfirmDialog} = useConfirmDialog()

    const {openSuccessDialog, SuccessDialog} = useSuccessDialog();

    const {openErrorDialog, ErrorDialog} = useErrorDialog();

    /**
     * セッション確認関数
     */
    const ConfirmSession = useContext(SessionContext);   

    /**
     * 編集完了関数
     */
    function CompleteEdit() {
        mutate();
        openSuccessDialog()
    }

    /**
     * 入力フォーム要素
     * @param param0 Props
     * @returns 
     */
    function FormWindow({CompleteEdit}:{CompleteEdit:() => void}) {

        /**
         * 入力フォームHook
         */
        const {register, handleSubmit, formState:{errors}} = useForm<FormInputType>({
            defaultValues: {
                heldTimesJP: heldTimes?.held_times_jp,
                heldTimesEN: heldTimes?.held_times_en,
            }
        });
    
        /**
         * 変更処理
         * @param data フォーム入力されたデータ
         * @returns 
         */
        async function onSubmit(data:FormInputType) {
    
            if(!await ConfirmSession()) {
                return;
            }
    
            await waitConfirm("開催回を変更します。よろしいですか？")
            .then(res => {
                res && PostChangeHeldTimes(data)
                .then(res => {
                    res ? CompleteEdit() : openErrorDialog();
                })
            })
    
        }

        return(
            <>
                <Grid2 xs={12}>
                    <Paper>
                        <Container maxWidth="sm">
                            <Box p={2}>                         
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid2 container spacing={2}>

                                        <Grid2 xs={12}>
                                            <TextField id="heldTimesJP" label="開催回(日本語)"
                                                error={errors.heldTimesJP ? true : false}
                                                helperText={errors.heldTimesJP ? "1文字以上、10文字以下で入力してください。" : ""}
                                                {...register("heldTimesJP",{
                                                    required: true,
                                                    minLength:1,
                                                    maxLength:10
                                                })}
                                                autoComplete="off"
                                            />
                                        </Grid2>
                                        
                                        <Grid2 xs={12}>
                                            <TextField id="heldTimesEN" label="開催回(英語)"
                                                error={errors.heldTimesEN ? true : false}
                                                helperText={errors.heldTimesEN ? "1文字以上、10文字以下で入力してください。" : ""}
                                                {...register("heldTimesEN",{
                                                    required: true,
                                                    minLength:1,
                                                    maxLength:10
                                                })}
                                                autoComplete="off"
                                            />
                                        </Grid2>
                                    </Grid2>
                                
                                    <Box p={2}>
                                        <Button type="submit" variant="contained">
                                            変更
                                        </Button>
                                    </Box>      
                                </form>              
                            </Box>
                        </Container>
                    </Paper>
                </Grid2>
            </>
        );
    }

    return(
        <>
            <Typography
                variant="h6"
            >
                開催回変更
            </Typography>
            
            {/* 開催回情報がロードされてからフォームを表示する */}
            {!isLoading ? <FormWindow CompleteEdit={CompleteEdit}/> : "" }

            <ConfirmDialog/>
            <SuccessDialog/>
            <ErrorDialog/>
        </>
    );
}